export const chairman = 'Chairman'
export const boardMember = 'Board Member'
export const substitute = 'Substitute'



// WEBPACK FOOTER //
// ./src/BoardMembers/responsibilityTypes.js